


























import {Component, Prop} from 'vue-property-decorator'
import VueBase from '@/pages/vue-base'
import Recruit from '@/models/Recruit'
import Job from '@/models/Job'
import Tag from '@/models/Tag'

@Component
export default class AddinTags extends VueBase {
  @Prop(Object) readonly value!: Recruit
  @Prop(Array) readonly tags!: Array<Tag>

  get selectedTagIds(): Array<number> {
    return this.value.viewableJobs.map(j => j.tag.id)
  }

  set selectedTagIds(value: Array<number>) {
    value.forEach(v => {
      // 追加
      const job = this.value.jobs.find(j => j.tag.id === v)
      if (job) {
        job.status = 'publish'
      // 復活
      } else {
        const newJob = new Job()
        this.tags.some(t => {
          newJob.tag = t.children.find(c => c.id === v)
          newJob.status = 'publish'
          return !!newJob.tag
        })
        this.value.jobs.push(newJob)
      }
    })

    this.value.jobs.forEach(job => {
      // 削除
      if (value.every(v => job.tag.id !== v)) {
        job.status = 'private'
      }
    })
  }

  status(tag: Tag): string {
    return this.value.jobs.find(j => j.tag.id === tag.id)?.status
  }
}
